export default {
  WelcomeMessage: 'Welcome to Spore',
  InputDataMessage: 'Enter your data',
  EmailLabel: 'Email',
  PasswordLabel: 'Password',
  ForgotPassword: 'Forgot password?',
  Enter: 'Enter',
  Messages:{
    ErrorLogin: 'User invalid.',
    MissingParams: 'Missing Params',
    Alert: 'Alert',
    Correct: 'Correct',
    State: 'State',
    Required: 'Field Required',
    EqualPassword: 'Passwords needs to be equals',
    None: 'None',
    EnterPassword:'Enter password',
    DatesRange: 'The start date cannot be greater than the end date',
    NotLuminaries: 'Luminaires not available to assign',
    NotAssignedLuminaries: 'No luminaires assigned',
    AlertsCircuit: 'The configured alerts will apply to all the luminaires in the circuit',
    AlertsAll: 'The configured alerts will apply to all the luminaires'
  },
  Labels:{
    Back: 'Back',
    Min: 'Min',
    Max: 'Max',
    Avg: 'Average',
    Time: 'Time',
    TimeUnity: 'Time Unity',
    DeviceLocation: 'Device location',
    Alerts: 'Alerts Config',
    LuminaryInformation: 'Luminary Information',
    ReportTime: 'Report Time',
    Save: 'Save',
    Filter: 'Filter',
    DeviceName: 'Device name',
    User: 'User | Users ',
    UserType: 'User Type',
    Admin: 'Administrator',
    Reader: 'Reader',
    Date: 'Date',
    Password: 'Password',
    ConfirmPassword: 'Confirm password',
    Email: 'Email',
    LastName: 'Last Name',
    Devices: 'Device | Devices',
    NotAssigned: 'No assigned',
    Assign: 'Assign',
    Assigned:'Assigned',
    SelectOne: 'Select one',
    AddUser:'Add user',
    EditUser: 'Edit user',
    Status: 'Status',
    Active: 'Active',
    Inactive: 'Inactive',
    Alias: 'Alias',
    Type: 'Type',
    LastUpdated: 'Last updated',
    Graphics: 'Graphics',
    Today: 'Today',
    Close: 'Close',
    Open: 'Open',
    LongOpen: 'Long Open',
    ConfigView: 'Config view',
    Client: 'Client',
    Contract: 'Contract',
    ContactNumber: 'Contact number',
    ClientNumber: 'Client number',
    Address: 'Address',
    Suburb:'Suburb',
    PostalCode:'PostalCode',
    City:'City',
    State:'State',
    Notifications:'Notifications',
    Measurement:'Measurement',
    Percent:'Percent',
    Battery:'Battery',
    LastCharge: 'Last charge',
    Analog:'Analog',
    Digital:'Digital',
    ChangeTo: 'Change to',
    SeeMore: 'See more',
    Second:'Second',
    Last24Hours:'Last 24 hours',
    Serie:'Serie',
    Name: 'Name',
    LastSeen: 'Last seen',
    Gauges: 'Gauges', 
    BatteryLevel: 'Battery level',
    ApproximateLitersSpent: 'Approximate liters consumed',
    DaysHours: 'Day\'s hours',
    Minimum: 'Minimum',
    Maximum: 'Maximum',
    Average: 'Average',
    Week: 'Week',
    Month: 'Month',
    Clean: 'Clean',
    TotalNumberOfGauges: 'Total number of gauges',
    Liters: 'Liters',
    To: 'To',
    From: 'From',
    Hours: 'Hours',
    Actives: 'Actives',
    Inactives: 'Inactives',
    InstallationOK : 'Installation OK',
    InstallationAlert : 'Installation Alert',
    Installed: 'Installed',
    ErrorInstallation: 'InstallationError',
    All: 'All',
    By: 'por',
    Total: 'Total',
    Range: 'Range',
    Signal: 'Signal',
    NoData: 'NoData',
    Previous: 'Previous',
    OrderBy:'Order by',
    History: 'History',
    Approximate: 'Approximate',
    ByPage: 'By page',
    ShowFilters: 'Show filters',
    HideFilters: 'Hide filters',
    Circuit: 'Circuit',
    CurrentConsumption: 'Current consumption',
    AccumulatedConsumption: 'Accumulated consumption',
    On: 'On',
    Off: 'Off',
    Show:'Show',
    LuminaryNumber: 'Luminary Number',
    Voltage: 'Voltage',
    Relay: 'Relay',
    Current: 'Current',
    Attenuation: 'Attenuation',
    LuminaryMeasurements: 'Luminary Measurements',
    ActivePower: 'Active Power',
    ReactivePower: 'Reactive Power',
    ApparentPower: 'Apparent Power',
    PowerFactor: 'PowerFactor',
    Power: 'Power',
    ActiveEnergy: 'Active Energy',
    ReactiveEnergy: 'Reactive Energy',
    Frequency: 'Frequency',
    Statistics: 'Statistics',
    Color:'Color',
    LuminariesCount: 'Luminaries Count',
    Cuantity: 'Cuantity',
    ShowControls: 'Show Controls',
    HideControls: 'Hide Controls',
    ShowConfigAlerts: 'Show alerts configuration',
    HideConfigAlerts: 'Hide alerts configuration',
    Apply: 'Apply',
    Accept: 'Accept',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    Inclination: 'Inclination',
    Dimming: 'Dimming',
    FailureVoltage: 'Voltage Failure',
    FailureCurrent: 'Current Failure',
    FailureRelay: 'Relay Failure',
    FailureDimming: 'Dimming Failure',
    FailureInclination: 'Inclination Failure',
    Alert: 'Alert',
    LastMonth: 'Last Month',
    LastWeek: 'Last Week',
    Add:'Add',
    Luminaries: 'Luminaries',
    Value: 'Value',
    NoError: 'No error',
    Error: 'Error',
    Summarized: 'Summarized',
    Fullscreen: 'Fullscreen',
    ExitFullscreen: 'Exit Fullscreen',
    StatisticsAll: 'All Luminaries Statistics',
    StatisticsCircuit: 'Circuit Statistics',
    NotAssignedToCircuit: 'Not Assigned to circuit',
    EnabledSelection:'Enabled selection',
    AssignToCircuit: 'Assign to circuit',
    SelectArea: 'To select an area, hold down the CTRL key',
    StartTime: 'Start time',
    EndTime: 'End time',
    StartDimming: 'Start dimming',
    EndDimming: 'End dimming',
    ControlDimming: 'Dimming control',
    Schedule: 'Schedule'
  },
  Dashboard:'Dashboard',
  Devices: 'Devices',
  Logout: 'Logout',
  Map: 'Map',
  Users: 'Users',
  Circuits: 'Circuits'    
}
